<template>
  <v-card>
    <v-card-title class="headline py-2">
      {{(editMode)?'Редактировать':'Добавить'}} объект учета
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="overflow-y: scroll">
      <v-container grid-list-xl class="pa-0">
        <v-layout v-if="showAfterSave" row wrap>
          <v-list>
            <v-list-tile v-for="(item, index) in existing" :key="index">
              <v-list-tile-content>
                <v-list-tile-sub-title><v-icon size="17" color="info">mdi-information</v-icon> Объект <b>{{computeName(item.properties)}}</b> не был создан, т.к. уже существует с именем <b>{{item.name}}</b></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-layout>
        <v-layout v-else row wrap>
          <v-flex xs12 md9>
            <v-text-field v-model="formObject.name" label="Название"></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field v-model="formObject.unit" label="Ед. измерения"></v-text-field>
          </v-flex>
          <v-flex xs12 class="py-0">
            <div class="mb-3">
              <label class="v-label theme--light" style="font-size: 13px">Описание</label>
              <dantser-editor v-model="formObject.description" :init="config" :api-key="apiKey"></dantser-editor>
            </div>
          </v-flex>
          <v-flex xs12>
            <dantser-tree
              label="Родительская папка"
              :source="foldersTree"
              ref="parentFolder"
              :field="true"
              :selectMode="1"
              @node-dblclick="setFolder($event)"
            >
            </dantser-tree>
          </v-flex>
          <v-flex xs12 :sm6="editMode" :sm5="!editMode">
            <p>Все признаки</p>
            <v-treeview v-model="tree" :items="objects" selected-color="primary" selectable return-object>
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" :color="item.iconcolor">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="">{{item.name}}</label>
            </v-treeview>
          </v-flex>
          <v-flex xs1 v-if="!editMode" style="position: relative;">
            <v-menu offset-y style="position: sticky; top: 40%;">
              <v-btn slot="activator" icon color="secondary"><v-icon>mdi-arrow-right</v-icon></v-btn>
              <v-list>
                <v-list-tile @click="addObject">
                  <v-list-tile-title>Только выбранные признаки</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="multuplyProperties">
                  <v-list-tile-title>Перемножить признаки</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6>
            <p>Результат</p>
            <span v-if="editMode">{{result}}</span>
            <v-list v-else>
              <v-list-tile v-for="(item, index) in formObject.objects" :key="index">
                <v-list-tile-content>
                  <v-list-tile-sub-title v-html="computeName(item)"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon @click="deleteObject(index)"><v-icon color="error">delete</v-icon></v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn v-if="showAfterSave" color="secondary" @click="$emit('close-dialog')">Закрыть</v-btn>
      <v-btn v-else color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import entities from '@/mixins/entities'
  
  export default {
    name : "ObjectForm",
    
    mixins: [entities],
    
    props:{
      data:{
        type: Object,
        required: false,
        default: () => { return {
          name: '',
          description: '',
          parent_id: null,
          unit: '',
          objects: [],
        }}
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    
    computed:{
      ...mapState('analytics', {
        config: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
      ...mapGetters('app/org', ['getPostById','getContainerById']),
      ...mapState(`analytics/constructor`, ['propertiesTree']),
      objects(){
        return this.propertiesTree.concat([
          { id: 'org', name: 'Оргструктура', children: this.treedata}
        ])
      }
    },
    
    created(){
      this.formObject = JSON.parse(JSON.stringify(this.data))
      this.getTrees()
    },
    
    data(){
      return {
        status:{
          btnDisabled: false,
          text: '',
          className:'success--text darken-1'
        },
        tab: null,
        formObject: {},
        treedata: [],
        foldersTree: [],
        tree: [],
        result: '',
        showAfterSave: false,
        existing: []
      }
    },
    
    methods:{
      getTrees(){
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.treedata = usersTree
          if(this.editMode) {
            this.$store.dispatch('analytics/constructor/getObject', this.data.id).then( response => {
              this.formObject = response
              this.formObject.id = this.data.id
              this.formObject.properties.map(item => {
                let id = (item.element_type==='property') ? item.property_id : item.identified
                this.tree.push({id})
              })
            })
          }
        })
        
        this.$store.dispatch('analytics/constructor/getFoldersTree', {id: 0, type: 'object'}).then( response => {
          response.unshift({ id: 0, name: 'Не выбрано', icon: 'mdi mdi-square' })
          this.foldersTree = response
          
          this.$nextTick(function(){
            if(this.formObject.parent_id!=null){
              this.$refs['parentFolder'].setSelected(this.formObject.parent_id)
            } else {
              this.$refs['parentFolder'].setSelected(0)
            }
          })
        })
      },
  
      computeName(line){
        let name = ''
        line.map( (item, index) => {
          let separator = (index===line.length-1) ? '' : ' -> '
          name += item.name+separator
        })
        return name
      },
  
      addObject(){
        let data = []
        this.tree.map( item => {
          if(item.element_type==='property' || item.element_type==='post'){
            if(item.element_type==='property'){
              data.push({element_type: item.element_type, property_id: item.id, identified: item.name, name: item.name})
            } else {
              data.push({element_type: item.element_type, identified: item.id, name: item.name})
            }
          }
        })
        this.formObject.objects.push(data)
        this.tree = []
      },
  
      deleteObject(index){
        this.formObject.objects.splice(index, 1)
      },
  
      multuplyProperties(){
        let propObject = {0: []}
        this.tree.map( item => {
          if(item.element_type==='property' || item.element_type==='post'){
            let data = {}
            if(item.element_type==='property'){
              data = {element_type: item.element_type, property_id: item.id, identified: item.name, name: item.name}
            } else {
              data = {element_type: item.element_type, identified: item.id, name: item.name}
            }
            if(item.parent_id===null) {
              propObject[0].push(data)
            } else {
              if(!propObject[item.parent_id]) propObject[item.parent_id] = []
              propObject[item.parent_id].push(data)
            }
          }
        })
        
        if(propObject[0] && propObject[0].length===0) delete propObject[0]
        let folders = Object.values(propObject)
        if(folders.length>1){
          this.formObject.objects = this.cartesian(...folders)
        } else if(folders.length===1){
          this.formObject.objects = folders
        }
        this.tree = []
      },
      
      setFolder(eventData){
        this.formObject.parent_id = eventData.id
      },
      
      submit(){
        this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }
        
        if(this.editMode){
          this.$store.dispatch('analytics/constructor/updateObject', this.formObject).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            this.$emit('close-dialog')
          }).catch( error => {
            let message = 'Ошибка при попытки отредактировать объект учета'
            if(error.response && error.response.status===422){
              message = ''
              let index = 1
              for(let field in error.response.data.errors){
                message+=(index++)+'. '+error.response.data.errors[field]+'\n'
              }
            } else if(error.response && error.response.data.message){
              message = error.response.data.message
            }
            if(error.response && error.response.status!==401) {
              this.$dmsErrorNoty(message)
              this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
            }
          })
        } else {
          this.$store.dispatch('analytics/constructor/createObject', this.formObject).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            if(response.old.length>0){
              this.showAfterSave = true
              this.existing = response.old
            } else {
              this.$emit('close-dialog')
            }
          }).catch( error => {
            let message = 'Ошибка при попытки создать объект учета'
            if(error.response && error.response.status===422){
              message = ''
              let index = 1
              for(let field in error.response.data.errors){
                message+=(index++)+'. '+error.response.data.errors[field]+'\n'
              }
            } else if(error.response && error.response.data.message){
              message = error.response.data.message
            }
            if(error.response && error.response.status!==401) {
              this.$dmsErrorNoty(message)
              this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
            }
          })
        }
      },
  
      cartesian(...arrays) {
        // находим число элементов в декартовом произведении
        let resultLength = 1;
        for (let array of arrays) {
          resultLength *= array.length;
        }
        // создаём массив такого размера и перебираем номер элемента
        let result = new Array(resultLength);
        for (let i = 0; i < resultLength; ++i) {
          // один элемент декартова произведения
          let element = new Array(arrays.length);
          let elementIndex = i;
          // цикл в обратном порядке нужен чтобы элементы начинали изменяться с конца
          for (let j = arrays.length - 1; j >= 0; --j) {
            const array = arrays[j];
            // имеем биекцию между индексами элементов декартова произведения (числа от 0 до resultLength-1)
            // и кортежами длины arrays.length, в которых каждый элемент — индекс в соответствующем массиве
            element[j] = array[elementIndex % array.length];
            // целочисленное деление
            elementIndex = Math.floor(elementIndex / array.length);
          }
          result[i] = element;
        }
        return result;
      }
    },
    
    watch:{
      tree(val){
        if(this.editMode){
          let tree = val.filter( item => (item.element_type && item.element_type!=='folder'))
          let objects = [], name = '', separator = '';
          tree.map( (item, index) => {
            if(item.element_type && tree.findIndex(el=>el.id===item.parent_id)<0){
              if(item.element_type==='property'){
                objects.push({
                  element_type: item.element_type,
                  identified: item.name,
                  property_id: item.id,
                })
              } else {
                objects.push({
                  element_type: item.element_type,
                  identified: item.id,
                })
              }
              name = name+item.name+' -> '
            }
          })
          this.result = name.slice(0, -3)
          this.formObject.properties = objects
        }
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Forms/ObjectForm.vue